import { render, staticRenderFns } from "./addSize.vue?vue&type=template&id=2d8378be&scoped=true"
import script from "./addSize.vue?vue&type=script&lang=js"
export * from "./addSize.vue?vue&type=script&lang=js"
import style0 from "./addSize.vue?vue&type=style&index=0&id=2d8378be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8378be",
  null
  
)

export default component.exports